import React from 'react';
import { Select, SelectProps } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';

// Select Dropdown Global Style (Portal로 body에 렌더링되므로 Global Style 필요)
export const SelectDropdownGlobalStyle = createGlobalStyle`
  .custom-select-dropdown {
    background: linear-gradient(rgba(0, 110, 73, 0.10), rgba(0, 110, 73, 0.10)), #1a1c1b !important;
    border-radius: 12px !important;
    border: 1px solid rgba(255, 255, 255, 0.20) !important;
    padding: 4px !important;
    min-width: 180px !important; /* 드롭다운 최소 너비 */

    .ant-select-item {
      color: #ffffff;
      border-radius: 8px;
      padding: 10px 16px;
      font-size: 14px;
      white-space: nowrap; /* 텍스트 줄바꿈 방지 */

      &:hover {
        background: rgba(255, 255, 255, 0.05) !important;
      }
    }

    .ant-select-item-option-active {
      background: rgba(255, 255, 255, 0.05) !important;
    }

    .ant-select-item-option-selected {
      background-color: rgba(0, 110, 73, 0.20) !important;

      &:hover {
        background-color: rgba(7, 217, 147, 0.25) !important;
      }
    }
  }

  .deposit-select-dropdown {
    background: linear-gradient(rgba(0, 110, 73, 0.10), rgba(0, 110, 73, 0.10)), #0c2323 !important;
    border-radius: 12px !important;
    border: 1px solid rgba(255, 255, 255, 0.20) !important;
    padding: 4px !important;

    .ant-select-item {
      color: #ffffff;
      border-radius: 8px;
      padding: 12px 16px;
      font-family: 'NanumSquareRound', sans-serif;
      font-size: 14px;
      font-weight: 700;

      &:hover {
        background: rgba(255, 255, 255, 0.05) !important;
      }
    }

    .ant-select-item-option-active {
      background: rgba(255, 255, 255, 0.05) !important;
    }

    .ant-select-item-option-selected {
      background-color: rgba(0, 110, 73, 0.20) !important;
      color: #07d993 !important;

      &:hover {
        background-color: rgba(7, 217, 147, 0.25) !important;
      }
    }
  }

  .inline-select-dropdown {
    background: linear-gradient(rgba(0, 110, 73, 0.10), rgba(0, 110, 73, 0.10)), #0c2323 !important;
    border-radius: 12px !important;
    border: 1px solid rgba(255, 255, 255, 0.20) !important;
    padding: 4px !important;
    width: 100% !important;
    left: 0 !important;
    top: calc(100% + 4px) !important;

    .ant-select-item {
      color: #ffffff;
      border-radius: 8px;
      padding: 12px 16px;
      font-family: 'NanumSquareRound', sans-serif;
      font-size: 14px;
      font-weight: 700;

      &:hover {
        background: rgba(255, 255, 255, 0.05) !important;
      }
    }

    .ant-select-item-option-active {
      background: rgba(255, 255, 255, 0.05) !important;
    }

    .ant-select-item-option-selected {
      background-color: rgba(0, 110, 73, 0.20) !important;
      color: #07d993 !important;

      &:hover {
        background-color: rgba(7, 217, 147, 0.25) !important;
      }
    }
  }
`;

// 기본 StyledSelect (Trade 설정용)
export const StyledSelect = styled(Select)`
  width: 100%;
  cursor: pointer;
  background-color: #2a2c2e;
  border-radius: 6px;
  height: 38px;

  .ant-select-selector {
    padding: 4px 12px !important;
    background: transparent !important;
    cursor: pointer !important;
    border: none !important;
  }

  .ant-select-arrow {
    color: #ffffff;
  }

  &:hover .ant-select-selector {
    border: none !important;
  }

  &.ant-select-focused .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
  }
` as typeof Select;

// Deposit 모달용 StyledSelect
export const DepositStyledSelect = styled(Select)`
  width: 100%;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  height: 50px;
  background: transparent;
  transition: all 0.2s;

  &:hover {
    border-color: rgba(255, 255, 255, 0.3);
  }

  .ant-select-selector {
    padding: 10px 20px !important;
    background: transparent !important;
    cursor: pointer !important;
    border: none !important;
    height: 100% !important;
  }

  .ant-select-selection-item {
    font-family: 'NanumSquareRound', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: -0.28px;
    display: flex;
    align-items: center;
  }

  .ant-select-arrow {
    color: #ffffff;
    right: 20px;
  }

  &:hover .ant-select-selector {
    border: none !important;
  }

  &.ant-select-focused {
    border-color: rgba(255, 255, 255, 0.3);
  }

  &.ant-select-focused .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
  }
` as typeof Select;

// Inline용 StyledSelect (border 없음, 부모 컨테이너가 border를 가짐)
export const InlineStyledSelect = styled(Select)`
  flex: 1;
  min-width: 0;
  cursor: pointer;
  background: transparent;

  .ant-select-selector {
    padding: 0 !important;
    background: transparent !important;
    cursor: pointer !important;
    border: none !important;
    height: 100% !important;
  }

  .ant-select-selection-item {
    font-family: 'NanumSquareRound', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: -0.28px;
    display: flex;
    align-items: center;
    padding-right: 0 !important;
  }

  .ant-select-arrow {
    color: #ffffff;
    right: 0;
    position: relative;
    margin-left: auto;
  }

  &:hover .ant-select-selector {
    border: none !important;
  }

  &.ant-select-focused .ant-select-selector {
    border: none !important;
    box-shadow: none !important;
  }
` as typeof Select;

// 기본 화살표 아이콘
export const ArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M7 9L10 12"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12L13 9"
        stroke="white"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

// 검색 아이콘 (Deposit 모달용)
export const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 19l-4.35-4.35"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export interface CSelectProps {
  variant?: 'default' | 'deposit' | 'inline';
  iconType?: 'arrow' | 'search';
  value?: string | number;
  options?: { value: string | number; label: React.ReactNode }[];
  onChange?: (value: string | number) => void;
  showSearch?: boolean;
  filterOption?: SelectProps['filterOption'];
  popupClassName?: string;
  getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;
  style?: React.CSSProperties;
}

/**
 * 공통 Select 컴포넌트
 *
 * @param variant - 'default' (Trade 설정용) 또는 'deposit' (Deposit 모달용)
 * @param iconType - 'arrow' (기본 화살표) 또는 'search' (검색 아이콘)
 *
 * @example
 * // 기본 사용
 * <CSelect
 *   value={selectedValue}
 *   options={options}
 *   onChange={(value) => setValue(value)}
 * />
 *
 * // Deposit 모달용
 * <CSelect
 *   variant="deposit"
 *   iconType="search"
 *   value={selectedCoin}
 *   options={coinOptions}
 *   onChange={(value) => setSelectedCoin(value)}
 * />
 */
const CSelect: React.FC<CSelectProps> = ({
  variant = 'default',
  iconType = 'arrow',
  popupClassName: customPopupClassName,
  getPopupContainer,
  ...props
}) => {
  const getSelectComponent = () => {
    switch (variant) {
      case 'deposit':
        return DepositStyledSelect;
      case 'inline':
        return InlineStyledSelect;
      default:
        return StyledSelect;
    }
  };

  const getDefaultPopupClassName = () => {
    switch (variant) {
      case 'deposit':
        return 'deposit-select-dropdown';
      case 'inline':
        return 'inline-select-dropdown';
      default:
        return 'custom-select-dropdown';
    }
  };

  const getDefaultPopupContainer = (trigger: HTMLElement) => {
    // inline variant의 경우 부모의 부모(DirectionRow)를 반환하여 dropdown이 전체 너비를 차지하도록
    if (variant === 'inline') {
      return trigger.parentElement?.parentElement || trigger.parentElement || document.body;
    }
    return trigger.parentElement || document.body;
  };

  const SelectComponent = getSelectComponent();
  const IconComponent = iconType === 'search' ? SearchIcon : ArrowIcon;

  return (
    <>
      <SelectDropdownGlobalStyle />
      <SelectComponent
        popupClassName={customPopupClassName || getDefaultPopupClassName()}
        suffixIcon={<IconComponent />}
        getPopupContainer={getPopupContainer || getDefaultPopupContainer}
        popupMatchSelectWidth={false} /* 드롭다운이 내용에 맞게 자동 조절 */
        {...props}
      />
    </>
  );
};

export default CSelect;
